"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));
var _hideFocusOnMouseClick = require("../../packages/hideFocusOnMouseClick");
var Styled = _interopRequireWildcard(require("./index.styled"));
require("./styles.css");
var _jsxRuntime = require("react/jsx-runtime");
const Tooltip = function (_ref) {
  let {
    hideOnScroll = true,
    shouldCloseOnScroll,
    boundary = "viewport",
    ...props
  } = _ref;
  const [isVisible, setVisible] = (0, _react.useState)(false);
  const instance = (0, _react.useRef)();
  const onCreate = function (tippy) {
    instance.current = tippy;
  };
  const handleOnShow = function () {
    var _instance$current$pop;
    (_instance$current$pop = instance.current.popperChildren.content.querySelector("video")) === null || _instance$current$pop === void 0 ? void 0 : _instance$current$pop.play();
    setVisible(true);
  };
  const handleOnHide = function () {
    setVisible(false);
  };
  (0, _react.useEffect)(function () {
    if (!hideOnScroll || !instance.current || !isVisible) return;
    const onScroll = function (event) {
      if (typeof shouldCloseOnScroll === "function" && !shouldCloseOnScroll(event)) return;
      if (instance.current.state.isVisible) {
        instance.current.hide();
      }
    };
    const onKeyDown = function (event) {
      if (event.key === "Escape") {
        event.stopPropagation();
        instance.current.hide();
      }
    };
    setTimeout(function () {
      instance.current.popperChildren.tooltip.focus();
      document.addEventListener("scroll", onScroll, true);
      document.addEventListener("keydown", onKeyDown, true);
    }, 0);
    return function () {
      document.removeEventListener("scroll", onScroll, true);
      document.removeEventListener("keydown", onKeyDown, true);
    };
  }, [hideOnScroll, instance, isVisible, shouldCloseOnScroll]);
  const modifiedProps = {
    ...props,
    className: [props.className, props.theme ? `${props.theme}-theme` : undefined].filter(function (i) {
      return typeof i !== "undefined";
    }).join(" "),
    popperOptions: {
      positionFixed: true
    },
    onShow: function () {
      handleOnShow();
      if (typeof props.onShow === "function") {
        props.onShow();
      }
    },
    onHide: function () {
      if (!isVisible) return;
      handleOnHide();
      if (typeof props.onHide === "function") {
        return props.onHide();
      }
      return true;
    },
    onCreate: function (tippy) {
      onCreate(tippy);
      if (typeof props.onCreate === "function") {
        props.onCreate(tippy);
      }
    },
    content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFocusLock.default, {
      autoFocus: false,
      returnFocus: true,
      disabled: !(0, _hideFocusOnMouseClick.isInAcessibilityMode)() || !isVisible,
      children: props.content
    })
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Tippy, {
      ...modifiedProps,
      boundary: boundary,
      aria: "labelledby"
    })
  });
};
var _default = exports.default = Tooltip;